<template>
    <section class="m-buy-house">
        <section class="m-banner">
            <img src="../../assets/images/house/banner.jpg" alt="">
        </section>
        <section class="move-news">
            <img src="../../assets/images/house/voice.png" alt="">
            <div class="slider">
                <van-swipe style="height: 0.6rem;" vertical :show-indicators="false" :autoplay="3000" :loop="true">
                    <van-swipe-item v-for="(item,index) in dongtailist" :key="index">
                        <div class="list">
                            <a :href="item.url">{{item.title}}</a>
                        </div>    
                    </van-swipe-item>
                </van-swipe>
            </div>
        </section>
        <section class="m-floor-1 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    展厅导航
                </span>
                <router-link to="/houselist">
                    <img src="../../assets/images/house/more.png" alt="">    
                </router-link>
            </div>
            <div class="nav-list">
                <ul>
                    <li class="first">
                        <router-link to="/houselist">
                            <p class="name">一手房区</p>
                            <p class="title">超值精品，抢到就是赚到。</p>
                            <p class="check">
                                <span>立即查看</span>        
                            </p>
                            <img src="../../assets/images/house/nav_icon_1.jpg" alt="">
                        </router-link>
                    </li>
                    <li class="second">
                        <router-link to="/houselist">
                            <p class="name">二手房区</p>
                            <p class="title">超值精品</p>
                            <p class="ico">
                                <img src="../../assets/images/house/nav_icon_2.jpg" alt="">       
                            </p>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/houselist">
                            <p class="name">家装区</p>
                            <p class="title">超值精品</p>
                            <p class="ico">
                                <img src="../../assets/images/house/nav_icon_3.jpg" alt="">       
                            </p>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/houselist">
                            <p class="name">建材区</p>
                            <p class="title">超值精品</p>
                            <p class="ico">
                                <img src="../../assets/images/house/nav_icon_4.jpg" alt="">       
                            </p>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/houselist">
                            <p class="name">家电区</p>
                            <p class="title">超值精品</p>
                            <p class="ico">
                                <img src="../../assets/images/house/nav_icon_5.jpg" alt="">       
                            </p>
                        </router-link>
                    </li>
                </ul>
            </div>
        </section>
        <section class="m-floor-2 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    秒杀活动
                </span>
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/more.png" alt="">    
                </router-link>
            </div>
            <div class="m-list">
                <ul>
                    <li v-for="(item,index) in miaoshalist" :key="index">
                        
                            <div class="pic">
                                <img :src="item.img" alt="">
                            </div>
                            <div class="name">{{item.title}}</div>
                            <div class="price">原   价：xxxxx元／㎡</div>
                            <div class="new-price">秒杀价：yyyy元／㎡</div> 
                            <div class="remain">剩余：2套</div>   
                        
                    </li>
                </ul>
            </div>
            <div class="m-ad">
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/ad.jpg" alt="">    
                </router-link>    
            </div>
        </section>
        <section class="m-floor-3 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    今日推荐
                </span>
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/more.png" alt="">    
                </router-link>
            </div>
            <div class="tab">
                <a href="javascript:;" v-for="(item,index) in tab" :key="index" :class="{'cur': curIndex === index}" @click="change(index)">{{item}}<span></span></a>
            </div>
            <div class="content" v-if="curIndex === 0">
                <ul>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                </ul>    
            </div>
            <div class="content" v-if="curIndex === 1">
                <ul>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                </ul>    
            </div>
            <div class="content" v-if="curIndex === 2">
                <ul>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                    <li>
                        <router-link to="/buyhouse">
                            <div class="pic">
                                <img src="../../assets/images/house/pic_1.jpg" alt="">
                            </div>
                            <div class="name">万科国际中心</div>
                            <div class="info">10套房源抢购中</div>  
                        </router-link>   
                    </li>
                </ul>    
            </div>
            <div class="msg-info">
                <div class="title">
                    <img src="../../assets/images/house/msg.png" alt="">    
                </div>
                <div class="list">
                    <ul>
                        <li v-for="(item,index) in msglist" :key="index">
                            <a :href="item.url">
                                <img src="../../assets/images/house/voice.png" alt="">
                                {{item.title}}   
                            </a>
                        </li>
                        
                    </ul>
                </div>
                <!--<div class="image">
                    <img src="../../assets/images/house/pic_2.jpg" alt="">    
                </div>-->
            </div>
        </section> 
        <section class="m-floor-4 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    活动专题
                </span>
                <router-link to="/gxnews/more/51139">
                    <img src="../../assets/images/house/more.png" alt="">    
                </router-link>
            </div>
            <div class="slider">
                <van-swipe :autoplay="3000">
                    <van-swipe-item v-for="(item,index) in huodonglist" :key="index" >
                        <a :href="item.url">
                            <img :src="item.img" alt="">    
                        </a>    
                    </van-swipe-item>
                    
                </van-swipe>
            </div>
        </section> 
        <section class="m-floor-5 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    品牌房企
                </span>
                <router-link to="/gxnews/more/51059">
                    <img src="../../assets/images/house/more.png" alt="">    
                </router-link>
            </div>
            <div class="slider">
                <van-swipe :autoplay="3000">
                    <van-swipe-item>
                        <ul>
                            <li v-for="(item,index) in fangqilist" :key="index" v-if="index<6">
                                <a :href="item.url">
                                    <img :src="item.img" alt="" height="60px">    
                                </a>
                            </li>
                        </ul>    
                    </van-swipe-item>
                    <van-swipe-item>
                        <ul>
                            <li v-for="(item,index) in fangqilist" :key="index" v-if="index>=6&&index<12">
                                <a :href="item.url">
                                    <img :src="item.img" alt="" height="60px">    
                                </a>
                            </li>
                        </ul>    
                    </van-swipe-item>
                    <van-swipe-item>
                        <ul>
                            <li v-for="(item,index) in fangqilist" :key="index" v-if="index>=12&&index<18">
                                <a :href="item.url">
                                    <img :src="item.img" alt="" height="60px">    
                                </a>
                            </li>
                        </ul>    
                    </van-swipe-item>
                </van-swipe>    
            </div>
            <div class="m-ad">
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/ad.jpg" alt="">    
                </router-link>    
            </div>    
        </section> 
        <section class="m-floor-6 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    大咖侃房
                </span>
                <router-link to="/gxnews/more/51137">
                    <img src="../../assets/images/house/more.png" alt="">    
                </router-link>
            </div>
            <swiper :options="swiperOption">
                <swiper-slide v-for="(item,index) in kanfanglist" :key="index">
                    <div class="list">
                        <a :href="item.url">
                            <div class="pic">
                                <img :src="item.img" alt="">    
                            </div>
                            <div class="title">
                                <i></i>
                                {{item.title}}    
                            </div>          
                        </a>
                    </div>
                </swiper-slide>
            </swiper>
        </section>
        <section class="m-floor-7 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    直播看房
                </span>
                <router-link to="/gxnews/more/51138">
                    <img src="../../assets/images/house/more.png" alt="">    
                </router-link>
            </div>
            <div class="list">
                <ul>
                    <li v-for="(item,index) in livelist" :key="index">
                        <a :href="item.url">
                            <div class="pic">
                                <i></i>
                                <img :src="item.img" alt="">
                            </div>
                            <div class="title">{{item.title}}</div>    
                        </a>    
                    </li>
                </ul>
            </div>
            <div class="m-ad">
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/ad.jpg" alt="">    
                </router-link>    
            </div>    
        </section>
        <section class="m-floor-8 floor">
            <div class="common-top">
                <span>
                    <i></i>
                    大家都在问
                </span>
                <router-link to="/buyhouse">
                    <img src="../../assets/images/house/more.png" alt="">    
                </router-link>
            </div>
            <div class="qa-list">
                <dl v-for="(item,index) in qalist" :key="index">
                    <dt>
                        <span>问</span>
                        {{item.title}}
                    </dt>
                    <dd>
                        <span>答</span>
                        {{item.content}}
                    </dd>
                </dl>
                <div class="ask-box">
                    <a href="http://www.gxnews.com.cn/app/borad.php?action=add&bid=484">我要提问</a>
                </div>
            </div>    
        </section> 
    </section>
</template>

<script>
    import jsonp from 'jsonp'
    import {swiper , swiperSlide} from 'vue-awesome-swiper'

    export default {
        data(){
            return{
                swiperOption:{
                    slidesPerView: 1.2
                },
                tab: ['热门新盘', '主推户型', 'VR看房'],
                curIndex: 0,
                dongtailist:[],
                msglist:[],
                huodonglist:[],
                miaoshalist:[],
                fangqilist:[],
                kanfanglist:[],
                livelist:[],
                qalist:[],
            }
        },
        methods:{
            change(index){
                this.curIndex = index;
            }
        },
        mounted () {
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51433&start=0&limit=6', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("dongtailist",data);
                    this.dongtailist = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51059&start=0&limit=18', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("fangqi",data);
                    this.fangqilist = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51139&start=0&limit=6', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("huodong",data);
                    this.huodonglist = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51134&start=0&limit=3', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("miaosha",data);
                    this.miaoshalist = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51137&start=0&limit=6', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("kanfang",data);
                    this.kanfanglist = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51138&start=0&limit=2', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("live",data);
                    this.livelist = data;
                }
            })
            jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=51433&start=0&limit=2', null, (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("msg",data);
                    this.msglist = data;
                }
            })
            jsonp(`https://www.gxnews.com.cn/app/borad.php?action=list&bid=484&type=json&simplecontent=1`, {} , (err, data) => {
                this.isLoading = false;
                if (err) {
                    console.error(err.message);
                } else {
                    console.log("qa",data);
                    this.qalist= data;
                }
            })  
            
        } 
    }
</script>

<style lang="less" scoped>
    .common-top{
        display: flex;
        align-items: center;
        margin-bottom: 0.45rem;
        span,a{
            flex: 1;
        }
        span{
            font-size: 0.45rem;
            color: #000;
            font-weight: bold;
        }
        i{
            display: inline-block;
            width: 0.1rem;
            height: 0.4rem;
            background: #48a4f7;
            border-radius: 0.2rem;
            vertical-align: middle;
        }
        a{
            text-align: right;
            font-size: 0.35rem;
            color: #adadad;
        }
        img{
            width: 20%;
        }
    }
    .floor{
        padding: 0 0.35rem;
    }
    .m-ad{
        margin-top: 0.6rem;
        img{
            width: 100%;
        }
    }
    .m-banner{
        img{
            width: 100%;
        }
    }
    .move-news{
        text-align: center;
        padding: 0.32rem 0;
        img{
            width: 5%;
        }
        .slider{
            display: inline-block;
            vertical-align: middle;
            .list{            
                margin-left: 0.1rem;
                a{
                    font-size: 0.36rem;
                    color: #000;
                }
            }
        }
    }
    .m-floor-1{
        ul{
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            flex-wrap: wrap;
        }
        li{
            width: 29.5%;
            background: #f6f7fc;
            border-radius: 0.35rem;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;
            margin-bottom: 0.35rem;
            text-align: center;
            padding: 0.2rem 0;
            &:nth-of-type(3),&:nth-of-type(4){
                margin-right: 0.5rem;
            }
            img{
                width: 50%;
            }
            p{
                margin-bottom: 0.08rem;
            }
            .name{
                font-size: 0.4rem;
                color: #000;
                font-weight: bold;
            }
            .title{
                font-size: 0.35rem;
                color: #b4b4b4;
            }
        }
        .first{
            width: 66%;
            margin-right: 0.35rem;
            padding: 0.3rem 0.45rem;
            text-align: left;
            img{
                display: block;
                position: absolute;
                right: 0;
                bottom: 0;
                width: 30%;
            }
            span{
                display: block;
                float: left;
                border-radius: 0.35rem;
                border: 1px solid #ec6244;
                padding: 0.03rem 0.3rem;
                color: #ec6244;
                font-size: 0.35rem;
            }
        }
        .second{
            width: 30%;
        }    
    }
    .m-floor-2{
        ul{
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            flex-wrap: wrap;   
        }
        li{
            width: 32.5%;
            box-sizing: border-box;
            padding: 0.12rem;
            background: #fff;
            box-shadow: 0.1rem 0.1rem 0.12rem #ccc;
            margin-right: 0.11rem;        
            font-size: 0.3rem;
            &:nth-last-of-type(1){
                margin-right: 0;    
            }
            a{
                color: #000;
            }
            img{
                width: 100%;
            }
            div{
                margin-top: 0.05rem;
            }
            .name,.remain{
                text-align: center;
                font-weight: bold;
                font-size: 0.37rem;
            }
            .name{
                color: #3b8af7;
            }
            .remain{
                color: #c72a29;
            }
        }
    }
    .m-floor-3{
        margin-top: 0.7rem;
        .tab{
            display: flex;
            padding-bottom: 0.15rem;
            border-bottom: 1px solid #b5b5b5;
            a{
                flex: 1;
                text-align: center;
                font-size: 0.36rem;
                color: #979797;
                position: relative;
            }
            .cur{
                color: #000;
                span{
                    display: block;
                }
            }
            span{
                display: none;
                position: absolute;
                width: 68%;
                height: 0.1rem;
                background: #c72a29;
                border-radius: 0.35rem;
                bottom: -0.2rem;
                left: 0.5rem;
            }
        }
        .content{
            margin-top: 0.45rem;
            ul{
                display: flex;
                justify-content: flex-start;
                flex-direction: row;
                flex-wrap: wrap;   
            }
            li{
                width: 32.5%;
                box-sizing: border-box;
                padding: 0.12rem;
                background: #fff;
                box-shadow: 0.1rem 0.1rem 0.12rem #ccc;
                margin-right: 0.11rem;        
                font-size: 0.3rem;
                &:nth-last-of-type(1){
                    margin-right: 0;    
                }
                a{
                    color: #000;
                }
                img{
                    width: 100%;
                }
                div{
                    margin-top: 0.05rem;
                }
                .name,.remain{
                    text-align: center;
                    font-weight: bold;
                    font-size: 0.37rem;
                }
                .name{
                    color: #3b8af7;
                }
                .info{
                    text-align: center;
                }
            }
        }
        .msg-info{
            margin-top: 0.7rem;
            overflow: hidden;
            .title{
                padding-right: 0.1rem;
                border-right: 1px solid #d2d2d2;
                float: left;
                img{
                    width: 80%;
                }
            }
            .list{
                width: 58%;
                float: left;
                box-sizing: border-box;
                padding: 0 0.25rem;
                li{
                    margin-top: 0.15rem;
                    img{
                        width: 10%;
                    }
                    a{
                        color: #000;
                        font-size: 0.3rem;
                    }
                }
            }
            .image{
                float: left;
                text-align: right;
                img{
                    width: 62%;
                }
            }
        }
    }
    .m-floor-4{
        margin-top: 0.7rem;
        .slider{
            img{
                width: 100%;
                border-radius: 0.25rem;
            }
        }
    }
    .m-floor-5{
        margin-top: 0.7rem;
        .slider{
            li{
                width: 33.3%;
                float: left;
                text-align: center;
                margin-bottom: 0.5rem;
            }
            img{
                width: 78%;
            }
        }
    }
    .m-floor-6{
        margin-top: 0.7rem;
        .list{
            float: left;
            margin-right: 0.3rem;
            img{
                width: 100%;
                border-radius: 0.3rem;
            }
            .title{
                margin-top: 0.1rem;
                font-size: 0.36rem;
                color: #000;
                i{
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.3rem;
                    height: 0.3rem;
                    background: url("../../assets/images/house/user.png") no-repeat;
                    background-size: 100%;
                    margin-right: 0.07rem;
                }
            }
        }
    }
    .m-floor-7{
        margin-top: 0.7rem;
        ul{
            display: flex;
            justify-content: flex-start;
            flex-direction: row;    
        }
        li{
            box-sizing: border-box;
            flex: 1;
            padding: 0.1rem;
            img{
                width: 100%;
            }
            .pic{
                position: relative;
            }
            i{
                width: 0.7rem;
                height: 0.7rem;
                background: url("../../assets/images/house/play_ico.png") no-repeat;
                background-size: 100%;
                display: block;
                position: absolute;
                left: 50%;
                top: 50%;
                margin: -0.3rem 0 0 -0.3rem;
            }
            .title{
                font-size: 0.32rem;
                color: #000;
                margin-top: 0.07rem;
            }
        }
    }
    .m-floor-8{
        margin-top: 0.7rem;
        padding-bottom: 2rem;
        dl{
            margin-bottom: 0.15rem;
        }
        dt{
            font-size: 0.32rem;
            margin-bottom: 0.25rem;
            span{
                display: inline-block;
                vertical-align: middle;
                border-radius: 0.2rem;
                background: #3b8af7;
                padding: 0.07rem 0.1rem;
                color: #fff;
                margin-right: 0.05rem;
            }
        }
        dd{
            font-size: 0.32rem;
            span{
                display: inline-block;
                vertical-align: middle;
                border-radius: 0.2rem;
                background: #a055f6;
                padding: 0.07rem 0.1rem;
                color: #fff;
                margin-right: 0.05rem;
            }    
        }
        .ask-box{
            margin-top: 0.25rem;
            text-align: center;
            a{
                display: inline-block;
                width: 40%;
                padding: 0.15rem 0;
                background: linear-gradient(to right, #53b6ea , #8cf8f1);
                color: #fff;
                font-size: 0.36rem;
                border-radius: 0.25rem;
                text-shadow: 0.05rem 0.05rem 0.07rem #000;
            }
        }
    }
</style>